var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useStore, useStoreMap } from "effector-react";
import { $trackSourceLoadingMap } from "./model";
import { $playerCurrentTrackSource } from "../../domain/player-track-queue";
export var useIsThisPlaylistLoading = function (id) {
    return useStoreMap({
        store: $trackSourceLoadingMap,
        keys: [id],
        fn: function (map, _a) {
            var _b = __read(_a, 1), playlistId = _b[0];
            return !!map.playlist[playlistId];
        },
    });
};
export var useIsThisTimetableLoading = function (id) {
    return useStoreMap({
        store: $trackSourceLoadingMap,
        keys: [id],
        fn: function (map, _a) {
            var _b = __read(_a, 1), timetableId = _b[0];
            return !!map.timetable[timetableId];
        },
    });
};
export var useIsCurrentTrackSourceLoading = function () {
    var currentTrackSource = useStore($playerCurrentTrackSource);
    return useStoreMap({
        store: $trackSourceLoadingMap,
        keys: [currentTrackSource],
        fn: function (map, _a) {
            var _b = __read(_a, 1), trackSource = _b[0];
            if (!trackSource)
                return false;
            if (trackSource.type === "playlist") {
                return !!map.playlist[trackSource.attributes.id];
            }
            if (trackSource.type === "today_timetable") {
                return !!map.timetable[trackSource.attributes.id];
            }
            return false;
        },
    });
};
